import {
  IonCol,
  IonGrid,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonList,
  IonRow,
} from "@ionic/react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { incrementPage } from "../../../store/documentList";
import { fetchDocuments } from "../../../store/documentList/actions/fetchDocuments";
import { selectDocuments } from "../../../store/documentList/selectors/selectDocuments";
import { selectFindStatus } from "../../../store/documentList/selectors/selectFindStatus";
import { selectViewMode } from "../../../store/documentList/selectors/selectViewMode";
import { DocumentCardItemList } from "./DocumentCardItemList";
import { DocumentItemList } from "./DocumentItemList";
import { DocumentSectionListLoading } from "./DocumentSectionListLoading";

export const DocumentsListSection: React.FC = () => {
  const dispatch = useDispatch();

  const documents = useSelector(selectDocuments);
  const viewMode = useSelector(selectViewMode);

  const [infiniteDisabled, setInfiniteDisabled] = useState<boolean>(false);
  const findStatus = useSelector(selectFindStatus);
  const loadData = (ev: any) => {
    setTimeout(() => {
      dispatch(incrementPage());
      dispatch(fetchDocuments());

      ev.target.complete();
      if (documents.length % 30 !== 0) {
        setInfiniteDisabled(true);
      }
    }, 500);
  };

  return (
    <section>
      {findStatus === "fulfilled" && documents.length === 0 && (
        <p className="ion-text-center" style={{ fontWeight: 300 }}>
          No se han encontrado resultados
        </p>
      )}

      {viewMode === "list" ? (
        <section className="ion-padding-horizontal">
          {documents?.map((document, index: number) => (
            <DocumentItemList document={document} key={index} />
          ))}
        </section>
      ) : (
        <IonGrid>
          <IonRow>
            {documents?.map((document, index: number) => (
              <IonCol size="12" sizeMd="6" sizeLg="4" key={index}>
                <DocumentCardItemList document={document} />
              </IonCol>
            ))}
          </IonRow>
        </IonGrid>
      )}

      {!documents.length && findStatus === "pending" && <DocumentSectionListLoading />}

      <IonInfiniteScroll onIonInfinite={loadData} threshold="10px" disabled={infiniteDisabled}>
        <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText="Cargar más datos..." />
      </IonInfiniteScroll>
    </section>
  );
};
